import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class FileManagementService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  kmlToGeoJson(file): Observable<any> {
    return this.http
      .post(this.apiBaseUrl + 'api/private/v1/kmlToGeoJson', file)
      .pipe(map((response) => response));
  }

  shapeToGeoJson(url): Observable<any> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/satellite/shapeToGeojson?url=' + url)
      .pipe(map((response) => response));
  }
}
